import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';

import {CustomSwitch} from 'components/elements';
import CreateAction from 'components/modals/CreateAction';
import {getActionLabel} from './Utils';
import {isComponentEnabledForUser, isComponentVisibleForUser} from 'utils';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';

const useStyles = makeStyles((theme) => ({
    hostManagement: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    hostStatus: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: '#fbfbfb',
        borderRadius: '5px',
        paddingLeft: theme.spacing(2), paddingRight: theme.spacing(2)
    },
    hostStatusColumn: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 13,

        '& .MuiSwitch-root': {
            width: 48,
            paddingRight: 0,
        },
    },
    actionButton: {
        height: 40,
        display: 'flex',
        flexDirection: 'column',

        '& button': {
            width: '100%',
            minWidth: 'unset',
        },
    },
    hostStatusLabel: {
        color: theme.palette.base[300],
        textTransform: 'uppercase',
    },
    hostStatusValue: {
        color: theme.palette.base[800],
        textTransform: 'uppercase',
    },
}));

function HostActions(props) {
    const classes = useStyles();
    const {t} = useTranslation();

    const {
        host,
        createParkingHostAction,
        userUseCases,
        hadleHostFavorite, 
        isHostFavorite
    } = props;

    const [openModal, setOpenModal] = useState(false);
    const [selectedAction, setSelectedAction] = useState(null);

    const clickAction = (co) => () => {
        setSelectedAction(co);
        setOpenModal(true);
    };

    const handleClose = () => {
        setOpenModal(false);
    };

    const hostSettingsTag = (setting) => {
        return isComponentVisibleForUser(`${UC_HOST_ACTION}${setting.actionName}`, userUseCases) ?
            <div className={classes.hostStatusColumn} key={`setting_${setting.actionName}`}>
                <div className={classes.hostStatusValue}>{getActionLabel(setting.actionName, t)}</div>
                <CustomSwitch
                    disabled={!isComponentEnabledForUser(`${UC_HOST_ACTION}${setting.actionName}`, userUseCases) || host.status === 'STATUS_RED'}
                    color="primary"
                    checked={setting.actionValue}
                    handleSwitch={clickAction(setting)}
                />
            </div> : null
    };

    return (
        <> { host ? (
            <div className={classes.hostManagement} >
                <div style={{display: 'flex', flexDirection: 'row', marginLeft: '-7px'}}>
                    <div style={{fontSize:14, opacity: 0.6, marginLeft: '20px', marginBottom: '10px'}}>{t('STANDS_CONTROL').toUpperCase()}</div>
                    <div style={{marginLeft:'auto', opacity: 0.5, cursor: 'pointer'}}>
                        { !isHostFavorite(host.parkingHostId, TYPE_FT_ACTION) &&
                            <FavoriteBorderIcon fontSize='small' onClick={()=>{hadleHostFavorite(host.parkingHostId, !isHostFavorite(host.parkingHostId, TYPE_FT_ACTION), TYPE_FT_ACTION)}}/>
                        }
                        { isHostFavorite(host.parkingHostId, TYPE_FT_ACTION) &&
                            <FavoriteIcon fontSize='small' onClick={()=>{hadleHostFavorite(host.parkingHostId, !isHostFavorite(host.parkingHostId, TYPE_FT_ACTION), TYPE_FT_ACTION)}}/>
                        }
                    </div>
                </div>
                <div className={classes.hostStatus}>
                    {host && host.actions && host.actions.map((hs) => hostSettingsTag(hs))}
                </div>

                {openModal && (
                    <CreateAction
                        action={selectedAction}
                        host={host}
                        opened={openModal}
                        handleClose={handleClose}
                        createParkingHostAction={createParkingHostAction}
                    />
                )}
            </div>) : null }
        </>
    )
}

HostActions.propTypes = {
    host: PropTypes.object,
    createParkingHostAction: PropTypes.func.isRequired,
    handleCreateTaskOpen: PropTypes.func.isRequired,
};

HostActions.defaultProps = {
    host: {actions: []},
};

const UC_TASK_CREATE = 'UC0038';
const UC_HOST_ACTION = 'UC0012_';
const TYPE_FT_ACTION = 'FT_ACTION';

export default HostActions;
